import { useQuery } from '@tanstack/react-query';
import { brgsApi } from '../api/brgs';
import { BrgDetailDto } from '../types';

export function useBrgDetail(id: string | undefined) {
  return useQuery<BrgDetailDto, Error>({
    queryKey: ['brgs', id],
    queryFn: () => brgsApi.getById(id!),
    enabled: !!id,
  });
}
